<template>
    <v-container>
        <v-card class="pl-10 pr-10">
            <v-card-title class="pb-0">
                <b>เพิ่มหนี้/ลดหนี้</b>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <UserBranchDropdown :pageCode="pageCode" @onUserBranchChange='setCurrentBranch'></UserBranchDropdown>
            </v-card-title>
            <v-divider></v-divider>

            <template>
                <v-container>
                    <v-card outlined>
                    <v-card-subtitle class="pb-0">
                        <v-row>
                        <v-col cols="4"> <v-text-field label="เลขที่ตั้งเบิก" placeholder=" " v-model="withdrawNo" outlined></v-text-field></v-col>
                        <v-col cols="4"> <v-text-field label="เลขที่ใบสั่งซ่อม" placeholder=" " v-model="jobNo" outlined></v-text-field></v-col>
                        </v-row>
                        <v-row>
                        <v-col cols="4"> <v-text-field label="เลขที่ใบประเมิน" placeholder=" " v-model="estimateNo" outlined></v-text-field></v-col>
                        <v-col cols="4"> <v-text-field label="ทะเบียนรถ" placeholder=" " v-model="licenseNo" outlined></v-text-field></v-col>
                        </v-row> 
                        <v-row><v-col> วันที่จบงานซ่อม </v-col> </v-row>
                        <v-row>
                            <v-col><DatePicker label="ตั้งแต่" @dateFormatted="setDateFrom" ></DatePicker></v-col>
                            <v-col><DatePicker label="ถึง" @dateFormatted="setDateTo" ></DatePicker></v-col>
                            <!-- <v-spacer></v-spacer> -->
                            <v-col class="text-right">
                                <v-row>
                                    <v-btn  class="ma-2" color="primary" small @click="search"><v-icon>search</v-icon> ค้นหา</v-btn>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-subtitle>
                    </v-card>
                </v-container>
            </template>
            <template>
            <v-data-table
                :headers="headers"
                :items="items"
                class="pt-5"
                >

                <template v-slot:item.action="{ item }">
                        <v-icon
                            small
                            @click="editData(item)"
                        >
                            edit
                        </v-icon>
                    </template>

            </v-data-table> 

            <!-- dialog -->
            <v-dialog v-model="editDialog"  width="600">
                            <template>
                            <div >
                                <v-card>
                                    <v-card-title style="background-color: rgb(21, 101, 192); color: white;">
                                    แก้ไขข้อมูล เพิ่ม/ลดหนี้
                                    </v-card-title>
                                 <!-- <v-form ref="form" v-model="valid" lazy-validation>  -->
                                    <v-card-text >


                                    <v-row> <v-col cols="6" sm="3">ทะเบียนรถ :  </v-col><v-col cols="6" sm="6"><v-text-field label="" placeholder=" " v-model="licenseNo" outlined cols="2" disabled></v-text-field> </v-col></v-row>
                                    <v-row> <v-col cols="6" sm="3">เลขที่ใบสั่งซ่อม : </v-col><v-col cols="6" sm="6"><v-text-field label="" placeholder=" " v-model="jobNo" outlined cols="2" disabled></v-text-field> </v-col></v-row>
                                    <v-row> <v-col cols="6" sm="3">เลขที่ใบประเมิน : </v-col><v-col cols="6" sm="6"><v-text-field label="" placeholder=" " v-model="estimateNo" outlined cols="2" disabled></v-text-field> </v-col></v-row> 
                                    <v-row> <v-col cols="6" sm="3">เลขที่ใบแจ้งหนี้ : </v-col><v-col cols="6" sm="6"><v-text-field label="" placeholder=" " v-model="invoiceNo" outlined cols="2" disabled></v-text-field> </v-col></v-row> 
                                    <v-row> <v-col cols="6" sm="3">ยอดตั้งเบิก : </v-col><v-col cols="6" sm="6"><v-text-field label="" placeholder=" " v-model="grandWdTotal" outlined cols="2" disabled></v-text-field> </v-col></v-row> 
                                     <v-btn
                                        color="primary"
                                        @click="resetData"
                                    >
                                        ยกเลิก เพิ่มหนี้/ลดหนี้
                                    </v-btn>
                                    <v-radio-group v-model="radios" :mandatory="false" @change="resetData" row :disabled="isDisable" >
                                       <v-col cols="6" sm="3"> <v-radio
                                            label="เพิ่มหนี้"
                                            value="addDebit"
                                        ></v-radio> </v-col>
                                        <v-col cols="6" sm="3">
                                        <v-radio
                                            label="ลดหนี้"
                                            value="reduceDebit"
                                        ></v-radio>
                                        </v-col>
                                    </v-radio-group>
                                     
                                    
                                    <v-row> <v-col cols="6" sm="3"> จำนวน : </v-col><v-col cols="6" sm="6"><v-text-field label="" type="number" :disabled="isDisable" placeholder=" " v-model="amount" outlined cols="2" @change="calculateData"></v-text-field> </v-col></v-row>
                                    <!-- <v-row> <v-col cols="6" sm="3"> VAT 7% : </v-col><v-col cols="6" sm="6"><v-text-field label="" placeholder=" " v-model="vat7" outlined cols="2" disabled></v-text-field> </v-col></v-row> -->
                                    <v-row> <v-col cols="6" sm="3"> ยอดตั้งเบิกสุทธิ : </v-col><v-col cols="6" sm="6"><v-text-field label="" placeholder=" " v-model="newGrandWdTotal" outlined cols="2" disabled></v-text-field> </v-col></v-row>
                                    <v-row> <v-col cols="6" sm="3">หมายเหตุ :  </v-col><v-col cols="6" sm="6"><v-text-field label="" placeholder=" " v-model="remark" outlined cols="2"></v-text-field> </v-col></v-row>
                                    </v-card-text>

                                    <v-divider></v-divider>

                                    <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        color="primary"
                                        @click="saveData"
                                        :disabled="isDisable"
                                    >
                                        บันทึก
                                    </v-btn>
                                    <v-btn
                                        color="primary"
                                        @click="close"
                                    >
                                        ยกเลิก
                                    </v-btn>
                                    </v-card-actions>
                                <!-- </v-form>  -->
                                </v-card>
                            </div>
                            </template>
                </v-dialog>

            </template>
        </v-card>
     </v-container>
</template>

<style>
  .v-text-field input {
    font-size: 1em;
  }
</style>

              
<script>
        import UserBranchDropdown from '@/components/Shared/UserBranchDropdown'
        import DatePicker from '@/components/Shared/DatePicker'
        import {list,updateData} from '@/api/accounting/addReduceDebit-api.js'
        import numeral from 'numeral'
            
       export default {
             name: 'Withdraw',
             components: {
                     UserBranchDropdown,
                     DatePicker
              },
             props:["pageCode"],
             data: () => ({
                rules: {
                    required: value => !!value || 'Required.'
                },
                isDisable : false,
                editDialog : false,
                // valid: false,
                radios: 'addDebit',
                branchCode: '',
                headers: [
                        {text: "วันที่จบงานซ่อม", value: "strInvoiceDate"},
                        {text: "ทะเบียน", value: "licenseNo"},
                        {text: "เลขที่ใบสั่งซ่อม", value: "jobNo"},
                        {text: "เลขที่ใบประเมิน", value: "estimateNo"},
                        {text: "เลขที่ใบแจ้งหนี้", value: "invoiceNo"},
                        {text: "ยอดเบิกสุทธิ", value: "grandWdTotalDisplay"},
                        {text: "เพิ่มหนี้", value: "addDebitDisplay"},
                        {text: "ลดหนี้", value: "reduceDebitDisplay"},
                        {text: "หมายเหตุ", value: "remark"},
                        {text: 'Actions', value: 'action', sortable: false}
                    ],
                items: [],
                dateFrom: null,
                dateTo: null,
                withdrawNo:'',
                jobNo:'',
                estimateNo:'',
                licenseNo:'',
                amount: 0,
                invoiceAmount: 0,
                grandWdTotal: 0,
                newGrandWdTotal: 0,
                oldGrandWdTotal: 0,
                percentWithdraw: 0,
                //vat7: 0,
                remark: '',
                addDebit: 0,
                reduceDebit: 0
              }),
            methods: {
            setDateFrom(val) {
                  this.dateFrom = val;
            },
            setDateTo(val) {
                  this.dateTo = val;
            },
            setCurrentBranch(branchCode) {
                this.branchCode = branchCode;
            },
            search(){

                this.$loading(true);
                list(this.withdrawNo,this.jobNo,this.estimateNo,this.licenseNo,this.dateFrom,this.dateTo, this.branchCode).then(response => {
                this.items = response;
                 if (this.items) {
                this.items.forEach((e) => {
                    e.grandWdTotalDisplay = numeral(e.grandWdTotal).format('0,0.00');
                    e.addDebitDisplay = numeral(e.addDebit).format('0,0.00');
                    e.reduceDebitDisplay = numeral(e.reduceDebit).format('0,0.00');
                    
                });
                }
                this.$loading(false);
                }).catch(()=> {
                    this.$loading(false);
                });
            },
            editData(item){

                this.$loading(true);
                this.withdrawNo = item.withdrawNo;
                this.jobNo = item.jobNo;
                this.estimateNo = item.estimateNo;
                this.invoiceNo = item.invoiceNo;
                this.licenseNo = item.licenseNo;
                this.invoiceAmount = item.invoiceAmount;
                this.percentWithdraw = item.percentWithdraw;
                this.estimateInvoiceId = item.estimateInvoiceId;
                this.remark = item.remark;
                this.amount = 0;

                if(item.addDebit != 0){
                    this.radios='addDebit';
                    this.amount = item.addDebit;
                    this.isDisable = true;
                }else if(item.reduceDebit != 0){
                    this.radios='reduceDebit';
                    this.amount = item.reduceDebit;
                    this.isDisable = true;
                }
                
                if(item.addDebit != 0 || item.reduceDebit != 0 ){
                    this.grandWdTotal = numeral(item.oldGrandWdTotal).format('0,0.00');
                    this.calculateData();
                    //this.newGrandWdTotal = numeral(item.grandWdTotal).format('0,0.00');
                }else{
                    this.grandWdTotal = numeral(item.grandWdTotal).format('0,0.00');
                    this.newGrandWdTotal = 0;
                }
                 this.$loading(false);

                this.editDialog = true;
            },
            saveData(){
                  //save data
                   this.$loading(true);

                   if(this.radios =='addDebit'){
                        this.addDebit = parseFloat(this.amount);
                        this.reduceDebit = 0;
                   }else{
                        this.addDebit = 0;
                        this.reduceDebit = parseFloat(this.amount);
                   }
                   var newGrandWdTotal = parseFloat(numeral(this.newGrandWdTotal).format('0.00'));
                   var oldGrandWdTotal = parseFloat(numeral(this.grandWdTotal).format('0.00'));
                   if(newGrandWdTotal == 0){
                       //case reset add/reduce
                        this.grandWdTotal = oldGrandWdTotal;
                   }else{
                        this.grandWdTotal = newGrandWdTotal;
                   }
                   
          //      }

                
                updateData(this.addDebit,this.reduceDebit,this.grandWdTotal,oldGrandWdTotal,this.estimateInvoiceId,this.remark).then(() => {
                this.$loading(false);
                this.close();
                }).catch(()=> {
                    this.$loading(false);
                });
                
            },
            resetData(){
                    this.amount = 0.00;
                   // this.vat7 = 0.00;
                    this.newGrandWdTotal = 0.00;
                    this.isDisable = false;
            },
            calculateData(){

                var _invoiceAmount = 0;
                 if(this.radios =='addDebit'){
                       _invoiceAmount =  parseFloat(this.invoiceAmount) + parseFloat(this.amount);
                   }else{
                       _invoiceAmount =   parseFloat(this.invoiceAmount) - parseFloat(this.amount);
                   }
                var newGrandTotal = _invoiceAmount  * (this.percentWithdraw/100.00);
               // var percentVat = newGrandTotal * 0.07 ;
               // this.vat7 = numeral(percentVat).format('0,0.00');
               // this.newGrandWdTotal =  numeral(newGrandTotal + percentVat).format('0,0.00');
               this.newGrandWdTotal =  numeral(newGrandTotal).format('0,0.00');

            },
            close(){
                this.editDialog = false;
                this.isDisable = false;
                this.clearSearch();
            },
            clearSearch(){
                this.withdrawNo = '';
                this.estimateNo = '';
                this.jobNo = '';
                this.licenseNo='';
                this.vat7= 0.00;
                this.search();
            }
            
        }
    }
</script>

